import React, { useState } from 'react';
import './styles/rider-details-Mobile.css';
import { Phone, MessageCircle, X } from 'lucide-react';
import CancelOrderModal from '@/pages/Profile/OrderDetails/components/CancelOrderModal';

interface RiderDetailsMobileProps {
  riderName?: string;
  riderPhone?: string;
  vehicleNumber?: string;
  orderId?: string;
  orderStatus?: string;
  trackingStatus?: string;
  onOrderCancelled?: () => void;
}

const RiderDetailsMobile: React.FC<RiderDetailsMobileProps> = ({
  riderName = 'Not Assigned',
  riderPhone,
  vehicleNumber,
  orderId,
  orderStatus,
  trackingStatus,
  onOrderCancelled
}) => {
  const [showCancelModal, setShowCancelModal] = useState(false);
  
  const handleCallRider = () => {
    if (riderPhone) {
      window.location.href = `tel:${riderPhone}`;
    }
  };

  const handleChatSupport = () => {
    const phoneNumber = '7617610660';
    const message = `Hey I need help with my order${orderId ? ` ${orderId}` : ''}`;
    const encodedMessage = encodeURIComponent(message);
    const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodedMessage}`;
    window.open(whatsappUrl, '_blank');
  };

  return (
    <div className="rider-details-mobile">
      {/* Rider Info */}
      <div className="rider-info-mobile">
        <p className="rider-name-mobile">Rider: {riderName}</p>
        <p className="vehicle-number-mobile">{vehicleNumber}</p>
      </div>

      {/* Action Buttons */}
      <div className="rider-actions-mobile">
        <button
          className="call-rider-btn-mobile"
          onClick={handleCallRider}
          disabled={!riderPhone}
        >
          <Phone size={18} />
          Call Rider
        </button>

        <button
          className="chat-support-btn-mobile"
          onClick={handleChatSupport}
        >
          <MessageCircle size={20} />
          Chat Support
        </button>
        
        {['pending', 'paid'].includes(orderStatus?.toLowerCase() || '') && trackingStatus?.toLowerCase() !== 'out_for_delivery' && (
          <button
            className="cancel-order-btn-mobile"
            onClick={() => setShowCancelModal(true)}
          >
            <X size={18} />
            Cancel Order
          </button>
        )}
      </div>
      
      {showCancelModal && orderId && (
        <CancelOrderModal
          orderId={orderId}
          orderStatus={orderStatus || ''}
          trackingStatus={trackingStatus || ''}
          onClose={() => setShowCancelModal(false)}
          onSuccess={() => {
            setShowCancelModal(false);
            onOrderCancelled?.();
          }}
        />
      )}
    </div>
  );
};

export default RiderDetailsMobile;